import slugify from './slugify';

export default ({ id, title }) => {
  let citySlugPath = '';
  if (window.city && window.city.slug) {
    citySlugPath = `${window.city.slug}/`;
  }

  return `/film/${slugify(title)}/${id}/${citySlugPath}`;
};
